import React from 'react';
import PropTypes from 'prop-types';

const EditableListItem = ({
  title, value, editing, input,
}) => (
  <li>
    <div className="im-list__label">{`${title}:`}</div>
    <div className="im-list__value">
      {
        editing
          ? input
          : value
      }
    </div>
  </li>
);

EditableListItem.propTypes = {
  title: PropTypes.string,
  value: PropTypes.string,
  editing: PropTypes.bool,
  input: PropTypes.element,
};

export default EditableListItem;
